import Client from '../HttpClient';

const list = (group) => {
	return Client.get(`/admin/api/sub-menu-link/group-subcategory/${group}`);
};

const listAll = () => {
	return Client.get(`/admin/api/sub-menu-link/list-all`);
};

const listByItem = (itemCode) => {
	return Client.get(`/admin/api/sub-menu-link/sub-division/${itemCode}`);
};

const find = (code) => {
	return Client.get(`/admin/api/sub-menu-link/${code}`);
};

const create = (payload) => {
	return Client.post('/admin/api/sub-menu-link', payload);
};

const update = (code, payload) => {
	return Client.put(`/admin/api/sub-menu-link/${code}`, payload);
};

export default {
	list,
	listAll,
	listByItem,
	find,
	create,
	update,
};
